export const comments_5618935 = {"data":{"data":[],"links":{}}}